module.exports = __webpack_public_path__ + "static/media/saayalogo.f70b8be7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/saayalogo.svg
// module id = 103
// module chunks = 5